<template>
  <div>
    <head>
      <meta charset="utf-8"/>
      <meta content="width=device-width, initial-scale=1.0" name="viewport">
      <meta content="Rental management system by Nouveta LTD" name="description"/>
      <meta content="Kelvin Njuguna" name="author"/>
      <!-- App favicon -->
      <link href="assets/images/favicon.png" rel="shortcut icon">
      <!-- droping file -->
      <link href="assets/libs/dropzone/min/dropzone.min.css" rel="stylesheet" type="text/css"/>
      <!-- DataTables -->
      <link href="assets/libs/datatables.net-bs4/css/dataTables.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <link href="assets/libs/datatables.net-buttons-bs4/css/buttons.bootstrap4.min.css" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap Css -->
      <link href="assets/css/bootstrap.min.css" id="bootstrap-style" rel="stylesheet" type="text/css"/>
      <!-- Bootstrap select styling -->
      <link href="https://cdn.jsdelivr.net/npm/bootstrap-select@1.13.14/dist/css/bootstrap-select.min.css" rel="stylesheet">
      <!-- Icons Css -->
      <link href="assets/css/icons.min.css" rel="stylesheet" type="text/css"/>
      <!-- App Css-->
      <link href="assets/css/app.min.css" id="app-style" rel="stylesheet" type="text/css"/>
      <!-- custom Css-->
      <link href="assets/css/custom.css" id="app-style" rel="stylesheet" type="text/css"/>
    </head>

    <body data-sidebar="dark">
    <!-- Begin page -->
    <div id="layout-wrapper">
      <NavigationBar/>

      <!-- Start right Content here -->
      <div id="content" class="content-minimize">
        <div class="page-content">
          <div class="container-fluid">

            <!-- Page title -->
            <div class="row">
              <div class="col-12">
                <div class="page-title-box d-sm-flex align-items-center justify-content-between">
                  <h4 class="mb-sm-0 font-size-18">SYSTEM INTEGRATIONS</h4>
                  <div class="page-title-right">
                    <ol class="breadcrumb m-0">
                      <li class="breadcrumb-item"><a @click="gotTo('dashboard')">Dashboards</a></li>
                      <li class="breadcrumb-item active">SYSTEM INTEGRATIONS</li>
                    </ol>
                  </div>
                </div>
              </div>
            </div>

            <!-- Alert Messages -->
            <div class="row" v-if="alert.success || alert.failed || alert.info">
              <div class="col-12">
                <div v-if="alert.success" class="alert alert-success alert-dismissible fade show" role="alert">
                  <strong>Success!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.success = false"></button>
                </div>
                <div v-if="alert.failed" class="alert alert-danger alert-dismissible fade show" role="alert">
                  <strong>Error!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.failed = false"></button>
                </div>
                <div v-if="alert.info" class="alert alert-info alert-dismissible fade show" role="alert">
                  <strong>Info!</strong> {{ message }}
                  <button type="button" class="btn-close" @click="alert.info = false"></button>
                </div>
              </div>
            </div>

            <!-- Integration Overview Stats -->
            <div class="row mb-4">
              <div class="col-md-3">
                <div class="card border-start border-5 border-success">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-success mb-1">{{ integrationStats.active }}</h3>
                        <p class="text-muted mb-0">Active Integrations</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-link-variant text-success fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-start border-5 border-warning">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-warning mb-1">{{ integrationStats.pending }}</h3>
                        <p class="text-muted mb-0">Pending Setup</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-clock-outline text-warning fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-start border-5 border-info">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-info mb-1">{{ integrationStats.dataSync }}</h3>
                        <p class="text-muted mb-0">Data Syncs Today</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-sync text-info fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div class="col-md-3">
                <div class="card border-start border-5 border-danger">
                  <div class="card-body">
                    <div class="d-flex justify-content-between">
                      <div>
                        <h3 class="text-danger mb-1">{{ integrationStats.errors }}</h3>
                        <p class="text-muted mb-0">Sync Errors</p>
                      </div>
                      <div class="align-self-center">
                        <i class="mdi mdi-alert-circle-outline text-danger fs-1"></i>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Integration Categories -->
            <div class="row mb-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-primary text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-source-branch me-2"></i>
                      System Integration Categories
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <!-- County Financial Systems -->
                      <div class="col-md-4 mb-3">
                        <div class="integration-category">
                          <div class="category-header bg-success text-white p-3 rounded-top">
                            <h5 class="mb-0 text-white">
                              <i class="mdi mdi-bank me-2"></i>
                              County Financial Systems
                            </h5>
                          </div>
                          <div class="category-body border border-top-0 p-3">
                            <div class="integration-item mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>IFMIS Integration</strong>
                                  <small class="d-block text-muted">Integrated Financial Management System</small>
                                </div>
                                <span class="badge bg-success">Active</span>
                              </div>
                            </div>
                            <div class="integration-item mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>Finance System</strong>
                                  <small class="d-block text-muted">County Financial Management</small>
                                </div>
                                <span class="badge bg-success">Active</span>
                              </div>
                            </div>
                            <div class="integration-item mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>HR & Payroll</strong>
                                  <small class="d-block text-muted">Human Resource Management</small>
                                </div>
                                <span class="badge bg-success">Active</span>
                              </div>
                            </div>
                            <div class="integration-item">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>Budget Management</strong>
                                  <small class="d-block text-muted">County Budget System</small>
                                </div>
                                <span class="badge bg-warning">Pending</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Government Systems -->
                      <div class="col-md-4 mb-3">
                        <div class="integration-category">
                          <div class="category-header bg-info text-white p-3 rounded-top">
                            <h5 class="mb-0 text-white">
                              <i class="mdi mdi-shield-account me-2"></i>
                              Government Systems
                            </h5>
                          </div>
                          <div class="category-body border border-top-0 p-3">
                            <div class="integration-item mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>KRA iTax</strong>
                                  <small class="d-block text-muted">Kenya Revenue Authority</small>
                                </div>
                                <span class="badge bg-success">Active</span>
                              </div>
                            </div>
                            <div class="integration-item mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>Business Registration</strong>
                                  <small class="d-block text-muted">eCitizen Business Portal</small>
                                </div>
                                <span class="badge bg-success">Active</span>
                              </div>
                            </div>
                            <div class="integration-item mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>NTSA</strong>
                                  <small class="d-block text-muted">Transport Authority</small>
                                </div>
                                <span class="badge bg-success">Active</span>
                              </div>
                            </div>
                            <div class="integration-item">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>NEMA</strong>
                                  <small class="d-block text-muted">Environmental Authority</small>
                                </div>
                                <span class="badge bg-warning">Pending</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <!-- Payment Systems -->
                      <div class="col-md-4 mb-3">
                        <div class="integration-category">
                          <div class="category-header bg-warning text-dark p-3 rounded-top">
                            <h5 class="mb-0">
                              <i class="mdi mdi-credit-card me-2"></i>
                              Payment Systems
                            </h5>
                          </div>
                          <div class="category-body border border-top-0 p-3">
                            <div class="integration-item mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>M-Pesa</strong>
                                  <small class="d-block text-muted">Mobile Money Payments</small>
                                </div>
                                <span class="badge bg-success">Active</span>
                              </div>
                            </div>
                            <div class="integration-item mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>Banking Integration</strong>
                                  <small class="d-block text-muted">Commercial Banks</small>
                                </div>
                                <span class="badge bg-success">Active</span>
                              </div>
                            </div>
                            <div class="integration-item mb-2">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>PesaLink</strong>
                                  <small class="d-block text-muted">Instant Bank Transfers</small>
                                </div>
                                <span class="badge bg-success">Active</span>
                              </div>
                            </div>
                            <div class="integration-item">
                              <div class="d-flex justify-content-between align-items-center">
                                <div>
                                  <strong>Card Payments</strong>
                                  <small class="d-block text-muted">Visa/Mastercard</small>
                                </div>
                                <span class="badge bg-warning">Pending</span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Integration Details Table -->
            <div class="row">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-white border-bottom">
                    <div class="d-flex justify-content-between align-items-center">
                      <h4 class="card-title mb-0">Integration Management</h4>
                      <div>
                        <button v-if="getRight('CONFIGURE INTEGRATIONS')"
                                class="btn btn-primary me-2"
                                data-bs-toggle="modal"
                                data-bs-target="#addIntegrationModal">
                          <i class="mdi mdi-plus-circle-outline font-size-16"></i>
                          <span class="d-md-inline ms-1">Add Integration</span>
                        </button>
                        <button @click="refreshIntegrations" class="btn btn-outline-success">
                          <i class="mdi mdi-refresh font-size-16"></i>
                          <span class="d-md-inline ms-1">Refresh Status</span>
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- Filters -->
                  <div class="card-header bg-white border-bottom">
                    <div class="row g-3 align-items-center">
                      <div class="col-md-3">
                        <label class="form-label mb-1">Category:</label>
                        <select @change="filterByCategory($event)" class="form-select">
                          <option value="">All Categories</option>
                          <option value="COUNTY_FINANCIAL">County Financial</option>
                          <option value="GOVERNMENT">Government Systems</option>
                          <option value="PAYMENT">Payment Systems</option>
                          <option value="THIRD_PARTY">Third Party</option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="form-label mb-1">Status:</label>
                        <select @change="filterByStatus($event)" class="form-select">
                          <option value="">All Status</option>
                          <option value="ACTIVE">Active</option>
                          <option value="INACTIVE">Inactive</option>
                          <option value="PENDING">Pending</option>
                          <option value="ERROR">Error</option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="form-label mb-1">Sync Frequency:</label>
                        <select @change="filterByFrequency($event)" class="form-select">
                          <option value="">All Frequencies</option>
                          <option value="REAL_TIME">Real-time</option>
                          <option value="HOURLY">Hourly</option>
                          <option value="DAILY">Daily</option>
                          <option value="MANUAL">Manual</option>
                        </select>
                      </div>

                      <div class="col-md-3">
                        <label class="form-label mb-1">Search:</label>
                        <div class="position-relative">
                          <input v-model="search" type="text" class="form-control" placeholder="Search integrations...">
                          <i class="bx bx-search-alt position-absolute top-50 end-0 translate-middle-y me-3"></i>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div class="card-body p-0">
                    <div class="table-responsive">
                      <table class="table table-hover mb-0">
                        <thead class="table-dark">
                        <tr>
                          <th class="text-nowrap">System Name</th>
                          <th class="text-nowrap">Category</th>
                          <th class="text-nowrap">Status</th>
                          <th class="text-nowrap">Last Sync</th>
                          <th class="text-nowrap">Sync Frequency</th>
                          <th class="text-nowrap">Data Flow</th>
                          <th class="text-nowrap">Health</th>
                          <th class="text-nowrap">Actions</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr v-for="(integration, index) in integrations" :key="index">
                          <td>
                            <div class="d-flex align-items-center">
                              <div class="avatar-sm rounded-circle bg-light me-3">
                                <i :class="getSystemIcon(integration.category)" class="fs-4"></i>
                              </div>
                              <div>
                                <strong>{{ integration.systemName }}</strong>
                                <small class="text-muted d-block">{{ integration.description }}</small>
                              </div>
                            </div>
                          </td>
                          <td>
                            <span class="badge" :class="getCategoryClass(integration.category)">
                              {{ formatCategory(integration.category) }}
                            </span>
                          </td>
                          <td>
                            <div class="d-flex align-items-center">
                              <span class="badge" :class="getStatusClass(integration.status)">
                                {{ integration.status }}
                              </span>
                              <div v-if="integration.isConnecting" class="spinner-border spinner-border-sm ms-2" role="status">
                                <span class="visually-hidden">Connecting...</span>
                              </div>
                            </div>
                          </td>
                          <td class="text-nowrap">{{ integration.lastSync }}</td>
                          <td>
                            <span class="badge bg-info">{{ integration.syncFrequency }}</span>
                          </td>
                          <td>
                            <div class="d-flex align-items-center">
                              <i v-if="integration.dataFlow.includes('IN')" class="mdi mdi-arrow-down text-success me-1" title="Data In"></i>
                              <i v-if="integration.dataFlow.includes('OUT')" class="mdi mdi-arrow-up text-warning me-1" title="Data Out"></i>
                              <i v-if="integration.dataFlow.includes('BIDIRECTIONAL')" class="mdi mdi-arrow-up-down text-info me-1" title="Bidirectional"></i>
                            </div>
                          </td>
                          <td>
                            <div class="progress" style="height: 6px;">
                              <div class="progress-bar" :class="getHealthClass(integration.health)"
                                   :style="{ width: integration.health + '%' }"></div>
                            </div>
                            <small class="text-muted">{{ integration.health }}%</small>
                          </td>
                          <td class="text-nowrap">
                            <div class="d-flex">
                              <button @click="viewIntegration(integration)"
                                      class="btn btn-primary btn-sm me-1"
                                      data-bs-toggle="modal"
                                      data-bs-target="#integrationDetailModal">
                                <i class="mdi mdi-eye"></i>
                              </button>
                              <button @click="testConnection(integration)"
                                      :disabled="integration.isConnecting"
                                      class="btn btn-outline-info btn-sm me-1">
                                <i class="mdi mdi-connection"></i>
                              </button>
                              <div class="dropdown">
                                <button class="btn btn-outline-secondary btn-sm dropdown-toggle"
                                        data-bs-toggle="dropdown">
                                  <i class="bx bx-dots-vertical"></i>
                                </button>
                                <ul class="dropdown-menu">
                                  <li>
                                    <a class="dropdown-item" @click="configureIntegration(integration)">
                                      <i class="mdi mdi-cog me-2"></i>Configure
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" @click="syncNow(integration)">
                                      <i class="mdi mdi-sync me-2"></i>Sync Now
                                    </a>
                                  </li>
                                  <li>
                                    <a class="dropdown-item" @click="viewLogs(integration)">
                                      <i class="mdi mdi-file-document me-2"></i>View Logs
                                    </a>
                                  </li>
                                  <li><hr class="dropdown-divider"></li>
                                  <li>
                                    <a class="dropdown-item" @click="toggleIntegration(integration)">
                                      <i :class="integration.status === 'ACTIVE' ? 'mdi mdi-pause' : 'mdi mdi-play'" class="me-2"></i>
                                      {{ integration.status === 'ACTIVE' ? 'Disable' : 'Enable' }}
                                    </a>
                                  </li>
                                </ul>
                              </div>
                            </div>
                          </td>
                        </tr>
                        </tbody>
                      </table>

                      <!-- No Results -->
                      <div v-if="integrations.length < 1" class="text-center p-5">
                        <img :src="'./assets/images/no-results.png'" class="img-fluid mb-4" alt="No results" style="max-width: 200px;">
                        <h4>No Integrations Found</h4>
                        <p>No system integrations match your current filter criteria.</p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            <!-- Data Flow Visualization -->
            <div class="row mt-4">
              <div class="col-12">
                <div class="card">
                  <div class="card-header bg-secondary text-white">
                    <h4 class="card-title mb-0 text-white">
                      <i class="mdi mdi-chart-sankey me-2"></i>
                      Real-time Data Flow Monitor
                    </h4>
                  </div>
                  <div class="card-body">
                    <div class="row">
                      <div class="col-md-8">
                        <div class="data-flow-diagram">
                          <div class="flow-container">
                            <!-- County Systems -->
                            <div class="flow-group county-systems">
                              <h6 class="text-center mb-3">County Systems</h6>
                              <div class="system-node bg-success text-white" data-system="revenue">
                                <i class="mdi mdi-bank"></i>
                                <small>Revenue System</small>
                              </div>
                              <div class="system-node bg-info text-white" data-system="finance">
                                <i class="mdi mdi-currency-usd"></i>
                                <small>Finance</small>
                              </div>
                              <div class="system-node bg-warning text-dark" data-system="hr">
                                <i class="mdi mdi-account-group"></i>
                                <small>HR & Payroll</small>
                              </div>
                            </div>

                            <!-- Data Flow Arrows -->
                            <div class="flow-arrows">
                              <div class="arrow-container">
                                <div class="flow-arrow" :class="{ 'active': dataFlowActive.ifmis }">
                                  <span class="flow-label">IFMIS</span>
                                </div>
                                <div class="flow-arrow" :class="{ 'active': dataFlowActive.payments }">
                                  <span class="flow-label">Payments</span>
                                </div>
                                <div class="flow-arrow" :class="{ 'active': dataFlowActive.business }">
                                  <span class="flow-label">Business Data</span>
                                </div>
                              </div>
                            </div>

                            <!-- External Systems -->
                            <div class="flow-group external-systems">
                              <h6 class="text-center mb-3">External Systems</h6>
                              <div class="system-node bg-primary text-white" data-system="kra">
                                <i class="mdi mdi-shield-account"></i>
                                <small>KRA iTax</small>
                              </div>
                              <div class="system-node bg-secondary text-white" data-system="business">
                                <i class="mdi mdi-office-building"></i>
                                <small>Business Reg</small>
                              </div>
                              <div class="system-node bg-dark text-white" data-system="payment">
                                <i class="mdi mdi-credit-card"></i>
                                <small>Payment Gateway</small>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>

                      <div class="col-md-4">
                        <div class="integration-metrics">
                          <h6 class="mb-3">Integration Metrics</h6>

                          <div class="metric-item mb-3">
                            <div class="d-flex justify-content-between">
                              <span>Data Sync Success Rate</span>
                              <strong class="text-success">98.5%</strong>
                            </div>
                            <div class="progress mt-1" style="height: 4px;">
                              <div class="progress-bar bg-success" style="width: 98.5%"></div>
                            </div>
                          </div>

                          <div class="metric-item mb-3">
                            <div class="d-flex justify-content-between">
                              <span>Average Response Time</span>
                              <strong class="text-info">245ms</strong>
                            </div>
                            <div class="progress mt-1" style="height: 4px;">
                              <div class="progress-bar bg-info" style="width: 75%"></div>
                            </div>
                          </div>

                          <div class="metric-item mb-3">
                            <div class="d-flex justify-content-between">
                              <span>API Calls Today</span>
                              <strong class="text-primary">12,458</strong>
                            </div>
                          </div>

                          <div class="metric-item mb-3">
                            <div class="d-flex justify-content-between">
                              <span>Failed Transactions</span>
                              <strong class="text-danger">23</strong>
                            </div>
                          </div>

                          <hr>

                          <h6 class="mb-3">Recent Sync Activities</h6>
                          <div class="activity-feed">
                            <div class="activity-item mb-2">
                              <div class="d-flex">
                                <div class="activity-icon bg-success rounded-circle me-2">
                                  <i class="mdi mdi-check text-white"></i>
                                </div>
                                <div class="flex-grow-1">
                                  <small><strong>IFMIS Sync</strong> completed successfully</small>
                                  <div class="text-muted" style="font-size: 0.75rem;">2 minutes ago</div>
                                </div>
                              </div>
                            </div>
                            <div class="activity-item mb-2">
                              <div class="d-flex">
                                <div class="activity-icon bg-info rounded-circle me-2">
                                  <i class="mdi mdi-sync text-white"></i>
                                </div>
                                <div class="flex-grow-1">
                                  <small><strong>KRA iTax</strong> data synchronization</small>
                                  <div class="text-muted" style="font-size: 0.75rem;">5 minutes ago</div>
                                </div>
                              </div>
                            </div>
                            <div class="activity-item mb-2">
                              <div class="d-flex">
                                <div class="activity-icon bg-warning rounded-circle me-2">
                                  <i class="mdi mdi-alert text-white"></i>
                                </div>
                                <div class="flex-grow-1">
                                  <small><strong>M-Pesa</strong> payment verification</small>
                                  <div class="text-muted" style="font-size: 0.75rem;">8 minutes ago</div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
        </div>

        <!-- Integration Detail Modal -->
        <IntegrationDetailModal
            :integrationDetail="selectedIntegration"
            @integration-configured="handleIntegrationConfigured"
        />

        <!-- Add Integration Modal -->
        <AddIntegrationModal
            @integration-added="handleIntegrationAdded"
        />

        <footer class="footer">
          <div class="container-fluid">
            <div class="row">
              <div class="col-sm-6"></div>
              <div class="col-sm-6">
                <div class="text-sm-end">Developed by County</div>
              </div>
            </div>
          </div>
        </footer>
      </div>
    </div>
    </body>
  </div>
</template>

<script>
/* eslint-disable */
import { authUrl, biller, execute, executeDownload, getRight } from "@/api";
import NavigationBar from "@/components/Navigation";
import IntegrationDetailModal from "@/components/integrations/modals/IntegrationDetailModal.vue";
import AddIntegrationModal from "@/components/integrations/modals/AddIntegrationModal.vue";
import router from "@/router";
import moment from "moment";

export default {
  name: "SystemIntegrationDashboard",
  components: {
    NavigationBar,
    IntegrationDetailModal,
    AddIntegrationModal
  },
  data() {
    return {
      search: '',

      // Integration statistics
      integrationStats: {
        active: 12,
        pending: 3,
        dataSync: 1247,
        errors: 2
      },

      // Data flow animation
      dataFlowActive: {
        ifmis: false,
        payments: false,
        business: false
      },

      // Integrations data
      integrations: [
        {
          id: 1,
          systemName: 'IFMIS',
          description: 'Integrated Financial Management Information System',
          category: 'COUNTY_FINANCIAL',
          status: 'ACTIVE',
          lastSync: '2025-01-16 14:30:00',
          syncFrequency: 'HOURLY',
          dataFlow: ['BIDIRECTIONAL'],
          health: 98,
          apiEndpoint: 'https://ifmis.treasury.go.ke/api',
          isConnecting: false
        },
        {
          id: 2,
          systemName: 'County Finance System',
          description: 'County Financial Management Platform',
          category: 'COUNTY_FINANCIAL',
          status: 'ACTIVE',
          lastSync: '2025-01-16 14:25:00',
          syncFrequency: 'REAL_TIME',
          dataFlow: ['BIDIRECTIONAL'],
          health: 95,
          apiEndpoint: 'https://finance.county.go.ke/api',
          isConnecting: false
        },
        {
          id: 3,
          systemName: 'HR & Payroll System',
          description: 'Human Resource and Payroll Management',
          category: 'COUNTY_FINANCIAL',
          status: 'ACTIVE',
          lastSync: '2025-01-16 14:00:00',
          syncFrequency: 'DAILY',
          dataFlow: ['IN'],
          health: 92,
          apiEndpoint: 'https://hr.county.go.ke/api',
          isConnecting: false
        },
        {
          id: 4,
          systemName: 'KRA iTax',
          description: 'Kenya Revenue Authority Tax System',
          category: 'GOVERNMENT',
          status: 'ACTIVE',
          lastSync: '2025-01-16 14:20:00',
          syncFrequency: 'DAILY',
          dataFlow: ['OUT'],
          health: 88,
          apiEndpoint: 'https://itax.kra.go.ke/api',
          isConnecting: false
        },
        {
          id: 5,
          systemName: 'Business Registration',
          description: 'eCitizen Business Registration Portal',
          category: 'GOVERNMENT',
          status: 'ACTIVE',
          lastSync: '2025-01-16 13:45:00',
          syncFrequency: 'HOURLY',
          dataFlow: ['IN'],
          health: 94,
          apiEndpoint: 'https://business.ecitizen.go.ke/api',
          isConnecting: false
        },
        {
          id: 6,
          systemName: 'NTSA',
          description: 'National Transport and Safety Authority',
          category: 'GOVERNMENT',
          status: 'ACTIVE',
          lastSync: '2025-01-16 14:10:00',
          syncFrequency: 'DAILY',
          dataFlow: ['IN'],
          health: 91,
          apiEndpoint: 'https://tims.ntsa.go.ke/api',
          isConnecting: false
        },
        {
          id: 7,
          systemName: 'M-Pesa Integration',
          description: 'Safaricom M-Pesa Payment Gateway',
          category: 'PAYMENT',
          status: 'ACTIVE',
          lastSync: '2025-01-16 14:32:00',
          syncFrequency: 'REAL_TIME',
          dataFlow: ['BIDIRECTIONAL'],
          health: 99,
          apiEndpoint: 'https://api.safaricom.co.ke/mpesa',
          isConnecting: false
        },
        {
          id: 8,
          systemName: 'Banking Integration',
          description: 'Commercial Banks Integration',
          category: 'PAYMENT',
          status: 'ACTIVE',
          lastSync: '2025-01-16 14:28:00',
          syncFrequency: 'HOURLY',
          dataFlow: ['IN'],
          health: 87,
          apiEndpoint: 'https://payments.centralbank.go.ke/api',
          isConnecting: false
        },
        {
          id: 9,
          systemName: 'PesaLink',
          description: 'Instant Inter-bank Transfer System',
          category: 'PAYMENT',
          status: 'ACTIVE',
          lastSync: '2025-01-16 14:15:00',
          syncFrequency: 'REAL_TIME',
          dataFlow: ['BIDIRECTIONAL'],
          health: 93,
          apiEndpoint: 'https://pesalink.co.ke/api',
          isConnecting: false
        },
        {
          id: 10,
          systemName: 'Budget Management',
          description: 'County Budget Planning System',
          category: 'COUNTY_FINANCIAL',
          status: 'PENDING',
          lastSync: 'Never',
          syncFrequency: 'DAILY',
          dataFlow: ['BIDIRECTIONAL'],
          health: 0,
          apiEndpoint: 'https://budget.county.go.ke/api',
          isConnecting: false
        },
        {
          id: 11,
          systemName: 'NEMA',
          description: 'National Environment Management Authority',
          category: 'GOVERNMENT',
          status: 'PENDING',
          lastSync: 'Never',
          syncFrequency: 'WEEKLY',
          dataFlow: ['IN'],
          health: 0,
          apiEndpoint: 'https://nema.go.ke/api',
          isConnecting: false
        },
        {
          id: 12,
          systemName: 'Card Payment Gateway',
          description: 'Visa/Mastercard Payment Processing',
          category: 'PAYMENT',
          status: 'PENDING',
          lastSync: 'Never',
          syncFrequency: 'REAL_TIME',
          dataFlow: ['BIDIRECTIONAL'],
          health: 0,
          apiEndpoint: 'https://gateway.payments.co.ke/api',
          isConnecting: false
        }
      ],

      selectedIntegration: {},

      // Alerts
      alert: {
        success: false,
        info: false,
        failed: false
      },
      message: ''
    }
  },
  mounted() {
    this.startDataFlowAnimation();
    this.menuAccess();
  },
  methods: {
    getRight,

    gotTo(route) {
      router.push(route);
    },

    // Animation for data flow
    startDataFlowAnimation() {
      setInterval(() => {
        // Randomly activate data flows
        this.dataFlowActive.ifmis = Math.random() > 0.7;
        this.dataFlowActive.payments = Math.random() > 0.6;
        this.dataFlowActive.business = Math.random() > 0.8;
      }, 2000);
    },

    // Utility methods
    getSystemIcon(category) {
      switch (category) {
        case 'COUNTY_FINANCIAL':
          return 'mdi mdi-bank text-success';
        case 'GOVERNMENT':
          return 'mdi mdi-shield-account text-info';
        case 'PAYMENT':
          return 'mdi mdi-credit-card text-warning';
        case 'THIRD_PARTY':
          return 'mdi mdi-api text-secondary';
        default:
          return 'mdi mdi-link-variant text-primary';
      }
    },

    getCategoryClass(category) {
      switch (category) {
        case 'COUNTY_FINANCIAL':
          return 'bg-success';
        case 'GOVERNMENT':
          return 'bg-info';
        case 'PAYMENT':
          return 'bg-warning';
        case 'THIRD_PARTY':
          return 'bg-secondary';
        default:
          return 'bg-primary';
      }
    },

    formatCategory(category) {
      const categories = {
        'COUNTY_FINANCIAL': 'County Financial',
        'GOVERNMENT': 'Government',
        'PAYMENT': 'Payment',
        'THIRD_PARTY': 'Third Party'
      };
      return categories[category] || category;
    },

    getStatusClass(status) {
      switch (status) {
        case 'ACTIVE':
          return 'bg-success';
        case 'INACTIVE':
          return 'bg-secondary';
        case 'PENDING':
          return 'bg-warning';
        case 'ERROR':
          return 'bg-danger';
        default:
          return 'bg-secondary';
      }
    },

    getHealthClass(health) {
      if (health >= 90) return 'bg-success';
      if (health >= 70) return 'bg-warning';
      if (health >= 50) return 'bg-danger';
      return 'bg-secondary';
    },

    // Filter methods
    filterByCategory(event) {
      // Implementation for category filtering
      console.log('Filter by category:', event.target.value);
    },

    filterByStatus(event) {
      // Implementation for status filtering
      console.log('Filter by status:', event.target.value);
    },

    filterByFrequency(event) {
      // Implementation for frequency filtering
      console.log('Filter by frequency:', event.target.value);
    },

    // Integration management methods
    viewIntegration(integration) {
      this.selectedIntegration = integration;
    },

    async testConnection(integration) {
      try {
        integration.isConnecting = true;

        // Simulate connection test
        await new Promise(resolve => setTimeout(resolve, 2000));

        // Random success/failure for demo
        const success = Math.random() > 0.2;

        if (success) {
          integration.health = Math.min(100, integration.health + Math.floor(Math.random() * 5));
          this.message = `Connection to ${integration.systemName} successful!`;
          this.alert.success = true;
        } else {
          integration.health = Math.max(0, integration.health - Math.floor(Math.random() * 10));
          this.message = `Connection to ${integration.systemName} failed!`;
          this.alert.failed = true;
        }

        integration.isConnecting = false;
      } catch (e) {
        integration.isConnecting = false;
        this.message = e.message;
        this.alert.failed = true;
      }
    },

    configureIntegration(integration) {
      this.selectedIntegration = integration;
      // Open configuration modal
      const modalElement = document.getElementById('integrationDetailModal');
      if (modalElement) {
        const modal = new bootstrap.Modal(modalElement);
        modal.show();
      }
    },

    async syncNow(integration) {
      try {
        this.message = `Starting manual sync for ${integration.systemName}...`;
        this.alert.info = true;

        // Simulate sync
        await new Promise(resolve => setTimeout(resolve, 3000));

        integration.lastSync = moment().format('YYYY-MM-DD HH:mm:ss');
        this.message = `Sync completed successfully for ${integration.systemName}`;
        this.alert.success = true;
      } catch (e) {
        this.message = `Sync failed for ${integration.systemName}: ${e.message}`;
        this.alert.failed = true;
      }
    },

    viewLogs(integration) {
      this.message = `Opening integration logs for ${integration.systemName}`;
      this.alert.info = true;
      // In real implementation, this would open a logs viewer
    },

    toggleIntegration(integration) {
      const newStatus = integration.status === 'ACTIVE' ? 'INACTIVE' : 'ACTIVE';
      integration.status = newStatus;

      this.message = `${integration.systemName} has been ${newStatus.toLowerCase()}`;
      this.alert.info = true;
    },

    refreshIntegrations() {
      this.message = "Refreshing integration status...";
      this.alert.info = true;

      // Simulate refresh
      setTimeout(() => {
        this.integrations.forEach(integration => {
          if (integration.status === 'ACTIVE') {
            integration.lastSync = moment().format('YYYY-MM-DD HH:mm:ss');
            integration.health = Math.min(100, integration.health + Math.floor(Math.random() * 3));
          }
        });

        this.alert.info = false;
        this.message = "Integration status refreshed successfully";
        this.alert.success = true;
      }, 2000);
    },

    // Event handlers
    handleIntegrationConfigured(integrationId, config) {
      const integration = this.integrations.find(i => i.id === integrationId);
      if (integration) {
        Object.assign(integration, config);
        this.message = `${integration.systemName} configuration updated successfully`;
        this.alert.success = true;
      }
    },

    handleIntegrationAdded(newIntegration) {
      this.integrations.unshift({
        id: this.integrations.length + 1,
        ...newIntegration,
        lastSync: 'Never',
        health: 0,
        isConnecting: false
      });

      this.integrationStats.pending++;
      this.message = `New integration ${newIntegration.systemName} added successfully`;
      this.alert.success = true;
    },

    menuAccess() {
      const data = new FormData();
      data.append("function", "menuAccess");
      data.append("menu", "System Integrations");
      data.append("sessionNames", sessionStorage.getItem("sessionNames"));
      data.append("sessionIdNo", sessionStorage.getItem("sessionIdNo"));

      execute(data, biller).catch(e => {
        console.error("Menu access error:", e.message);
      });
    }
  }
}
</script>

<style scoped>
.integration-category {
  height: 100%;
}

.category-header {
  border-radius: 0.375rem 0.375rem 0 0 !important;
}

.category-body {
  border-radius: 0 0 0.375rem 0.375rem !important;
  min-height: 200px;
}

.integration-item {
  padding: 0.5rem;
  border-radius: 0.25rem;
  transition: background-color 0.15s ease-in-out;
}

.integration-item:hover {
  background-color: #f8f9fa;
}

.avatar-sm {
  width: 3rem;
  height: 3rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.data-flow-diagram {
  background: linear-gradient(135deg, #f8f9fa 0%, #e9ecef 100%);
  border-radius: 0.5rem;
  padding: 2rem;
  min-height: 300px;
}

.flow-container {
  display: flex;
  justify-content: space-between;
  align-items: center;
  height: 100%;
}

.flow-group {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  flex: 1;
}

.system-node {
  padding: 1rem;
  border-radius: 0.5rem;
  text-align: center;
  min-height: 80px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  box-shadow: 0 2px 4px rgba(0,0,0,0.1);
  transition: transform 0.2s ease, box-shadow 0.2s ease;
}

.system-node:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 8px rgba(0,0,0,0.15);
}

.system-node i {
  font-size: 1.5rem;
  margin-bottom: 0.5rem;
}

.flow-arrows {
  flex: 0 0 200px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
}

.flow-arrow {
  position: relative;
  width: 120px;
  height: 4px;
  background: #dee2e6;
  border-radius: 2px;
  transition: all 0.3s ease;
}

.flow-arrow.active {
  background: linear-gradient(90deg, #007bff, #28a745);
  animation: flowPulse 1.5s ease-in-out infinite;
}

.flow-arrow::after {
  content: '';
  position: absolute;
  right: -8px;
  top: -4px;
  width: 0;
  height: 0;
  border-left: 8px solid #dee2e6;
  border-top: 6px solid transparent;
  border-bottom: 6px solid transparent;
  transition: border-left-color 0.3s ease;
}

.flow-arrow.active::after {
  border-left-color: #28a745;
}

.flow-label {
  position: absolute;
  top: -25px;
  left: 50%;
  transform: translateX(-50%);
  font-size: 0.75rem;
  color: #6c757d;
  white-space: nowrap;
}

@keyframes flowPulse {
  0%, 100% { opacity: 1; }
  50% { opacity: 0.6; }
}

.integration-metrics {
  background: #f8f9fa;
  border-radius: 0.5rem;
  padding: 1.5rem;
  height: 100%;
}

.metric-item {
  padding: 0.75rem;
  background: white;
  border-radius: 0.375rem;
  border: 1px solid #dee2e6;
}

.activity-feed {
  max-height: 200px;
  overflow-y: auto;
}

.activity-icon {
  width: 24px;
  height: 24px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 0.75rem;
  flex-shrink: 0;
}

.progress {
  height: 6px;
}

.badge {
  font-size: 0.75rem;
}

.btn-sm {
  padding: 0.25rem 0.5rem;
  font-size: 0.75rem;
}

.spinner-border-sm {
  width: 0.875rem;
  height: 0.875rem;
}

.fs-1 {
  font-size: 2rem !important;
}

.border-start {
  border-left-width: 5px !important;
}

.table th {
  white-space: nowrap;
  vertical-align: middle;
}

.table td {
  vertical-align: middle;
}
</style>